<template>

	<div >
		<!-- toasts message -->
		<Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
		<!-- /toasts message -->
		<v-layout>
			<v-flex xs12 sm12>
				<v-card style="padding:10px;">
					<v-card-title>
						
						<div v-if="ActionStatus" class="text-positive"> 
							<div class="item-content"> {{ actionMessage }}</div>
						</div>
						<div v-else>
							<div v-if ="actionMessage" class="text-negative">
								<p class="caption text-negative">Fix Following Input Errors :</p>
								<div class="item text-negative" v-for="(err, index) in actionMessage" :key="index">
									<div class="item-content">  {{err}} </div>
								</div> 
								<v-card-title primary-title v-for="(err2, index2) in actionMessage" :key="index2">{{err2}}</v-card-title>  
							</div>
						</div>
					</v-card-title>

					<v-inner-loading v-if ="ActionProcess">
						<v-spinner-gears size="50px" color="primary"></v-spinner-gears>
					</v-inner-loading> 
					<div class="text-center headline" style="padding:8px;"> {{formTitle }}  - {{formRoleSchema.role_name }} 							
					</div>					
					<hr>
					<v-form >						
						<v-card-actions>
							<v-checkbox
							label="Select All"
							v-model="selectAll"
							v-on:click.native="checkAll(this)"
							></v-checkbox>								
							<!--  {{allMenuList}} -->
							<v-spacer></v-spacer>
							<v-btn v-if="allMenuList.length>0" @click="permissionSubmit" color="success" >
								<v-icon>save</v-icon> Save 
							</v-btn>

							<v-btn color="error white--text" @click="closeModalChild">
								<v-icon>arrow_back_ios</v-icon>Previous
							</v-btn>
						</v-card-actions>

						<v-layout row wrap>
							<v-flex xs12 sm8 offset-sm2 class="mb-4" v-for="(mainMenus,index) in allMenuList" :key="index">						

								<table width="100%" border="0" class="permission">
									<tbody >
										<tr>
											<th colspan="2" style="text-align: left;color: green;padding: 5px;">
												<v-checkbox 			
												style="margin:0px !important"
												hide-details
												v-model="subMenu"
												:value="mainMenus.id"
												:label="mainMenus.menu_name"
												v-on:click.native="checkSubMenu(index)"
												></v-checkbox>
												<!-- {{mainMenus.menu_name}} -->
											</th>
										</tr>
										<tr>
											<th width="30%">Submenu Title</th>
											<th>Permission</th>
										</tr>
										<tr v-for="(menus,key) in mainMenus.childs" :key="key">
											<td width="30%" class="pl-1 py-0">{{menus.submenu_name}}</td>
											<td>
												<div class="tableTd">
													<v-checkbox 
													style="margin:0px !important"
													hide-details
													v-model="menus.read"
													label="View"
													></v-checkbox>
												</div>

												<div class="tableTd">
													<v-checkbox 
													style="margin:0px !important"
													hide-details
													v-model="menus.save"
													label="Save"
													></v-checkbox>
												</div>

												<div class="tableTd">
													<v-checkbox 
													style="margin:0px !important"
													hide-details
													v-model="menus.update"
													label="Update"
													></v-checkbox>
												</div>

												<div class="tableTd">
													<v-checkbox 
													style="margin:0px !important"
													hide-details
													v-model="menus.delete"
													label="Delete"
													></v-checkbox>
												</div>
											</td>
										</tr>
									</tbody>
								</table>

							</v-flex>
						</v-layout>


						
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn v-if="allMenuList.length>0" @click="permissionSubmit" color="success" >
								<v-icon>save</v-icon> Save 
							</v-btn>

							<v-btn color="error white--text" @click="closeModalChild">
								<v-icon>arrow_back_ios</v-icon>Previous
							</v-btn>							
						</v-card-actions>							

					</v-form>
				</v-card>
			</v-flex>
		</v-layout>
	</div>	
</template>			




<script> 
import axios from 'axios'
import {preFix} from '../../vuex/api'

const commonService = require('../../services/common.service');

export default {

	data () {
		return {
			formTitle: "User Role Details",	
			model: '',
			errorMsg: " ",
			errorClass: "text-red",
			role_id:0,
			submenu_id:0,	
			form:[],			
			userRoleList:[],
			submenuList:[], 
			formatedList:[], 
			allMenuList : [],
			permissionModal:false,

			SnackbarVal: {
				snackbar: false,
				color: "success",
				message: ""
			},

			selectAll: false,
			subMenu:false,

			formSchema2:{
				id:'',
				menuList:[],
				role_id:'',
			}
		}
	},

	created:function(){
		let root = this;
		commonService.getAllData('get-drop-down-data').then( res => {        
			root.userRoleList = res.userRole				
			root.submenuList = res.submenu
		});		
	},

	methods: {
		processList: function(){
			this.allMenuList.forEach(function(item){					
				if(item.read == "1" ) 
					item.read = true; else item.read = false;
				if(item.save == "1" ) 
					item.save = true ; else item.save = false;
				if(item.update == "1" ) 
					item.update = true ;else item.update = false;	
				if(item.delete == "1" ) 
					item.delete = true ; else item.delete = false;
			})
		},

		closeModalChild: function ($action) {
			this.$emit('emitCloseModal', $action)
		},

		permissionSubmit(e) {

			var formSchema2 = this.formSchema2
			formSchema2.id = this.formRoleSchema.id
			formSchema2.menuList = this.allMenuList
			formSchema2.role_id = this.formRoleSchema.id;

			commonService.updateFormData(formSchema2, 'role-wise-access').then(res => {
				if(res.status == 'success')
				{
					/*this.message = res.message;       
					this.snackbar = true 
					this.closeModalChild(1);*/

					this.SnackbarVal.message = 'Data saved successfully!';
					this.SnackbarVal.snackbar = true;
					this.SnackbarVal.color = "success";
				}
			});				
		},


		formReset: function(){
			this.$store.commit('SYSUSERROLEDET_UNSET_SCHEMA')
		},

		checkAll: function (ele) {				
			var checkVal = this.selectAll.toString();				

			if(checkVal == 'true')
			{
				this.allMenuList.forEach(function(itemV){	
					itemV.childs.forEach(function(item){
						item.read = true; 			
						item.save = true ;
						item.update = true;
						item.delete = true;
					})				
				});
			}
			else
			{
				this.allMenuList.forEach(function(itemV){
					itemV.childs.forEach(function(item){						
						item.read = false; 			
						item.save = false ;
						item.update = false;
						item.delete = false;
					})

				});
			}				

		},

		checkSubMenu(index){
			
			var checkVal = this.subMenu;
			let menus = this.allMenuList[index];
			
			if(checkVal>0)
			{
				menus.childs.forEach(function(item){
					item.read = true; 			
					item.save = true ;
					item.update = true;
					item.delete = true;
				})				
			}
			else
			{
				menus.childs.forEach(function(item){						
					item.read = false; 			
					item.save = false ;
					item.update = false;
					item.delete = false;
				})
			}

		},

		closeModalChild()
		{			
			this.$store.commit('SYSUSERROLE_UNSET_SCHEMA');
			this.allMenuList = [];
			this.$router.push('/user/role');			
		},

	},

	computed: {

		userRole(){
			return this.$store.getters.get_USER_ROLE_DATA
		},
		ActionStatus(){
			return this.$store.getters.get_SYSUSERROLEDET_ActionStatus  
		},	
		ActionProcess(){
			return this.$store.getters.get_SYSUSERROLEDET_ActionProcess  
		},	
		actionMessage(){
			return this.$store.getters.get_SYSUSERROLEDET_ActionMessage ;
		},  
		formSchema(){
			return this.$store.getters.get_SYSUSERROLEDET_Schema ;
		},
		formRoleSchema(){				

			var role_id = this.$store.getters.get_SYSUSERROLE_Schema.id;
			this.role_id = role_id
			var root = this	
			if ( role_id > 0 ) {
				commonService.getAllData('get-role-details/'+role_id).then( res => { root.allMenuList = res.menuList
					root.processList()	
				})
			}
			return this.$store.getters.get_SYSUSERROLE_Schema ;
		}
	}

};
</script>

<style>
table.permission{
	border-collapse: collapse;
}
table.permission th{
	font-size: 14px;
	border: 1px solid #CCC;
	line-height:35px;
}

table.permission td{
	border: 1px solid #CCC;
	font-size: 12px !important;
}
.fontBold{
	font-weight: bolder;
}
.tableTd{
	display: inline-block;		
}
</style>


// WEBPACK FOOTER //
// src/components/Userrole/setRolePermission.vue